export default __webpack_public_path__ + "static/media/testimonial-3.7dec9d18.svg";